import { StyleSheet, Text, View } from "react-native";
import { useTranslation } from "@luna-restaurant/i18n";
import { useCustomTheme } from "@luna-restaurant/ui";
const weekdays = [
    "common.weekdays.monday",
    "common.weekdays.tuesday",
    "common.weekdays.wednesday",
    "common.weekdays.thursday",
    "common.weekdays.friday",
];
export const WeeklyGridHeader = () => {
    const { colors, fonts } = useCustomTheme();
    const { t } = useTranslation();
    return (<View style={styles.headerContainer}>
      {weekdays.map((dayLabel) => (<View key={dayLabel} style={[styles.headerCell, { backgroundColor: colors.border }]}>
          <Text style={[
                styles.headerText,
                { color: colors.background, ...fonts.medium, ...fonts.bold },
            ]}>
            {t(dayLabel)}
          </Text>
        </View>))}
    </View>);
};
const styles = StyleSheet.create({
    headerContainer: {
        flexDirection: "row",
        position: "sticky",
        top: 16,
        zIndex: 100,
        marginTop: 33,
        marginBottom: 24,
        gap: 8,
        height: 44,
    },
    headerCell: {
        flex: 1,
        padding: 16,
        justifyContent: "center",
        borderRadius: 8,
        boxShadow: "0px 8px 16px 0px #0000001A",
    },
    headerText: {
        fontSize: 15,
        lineHeight: 18,
    },
});
//# sourceMappingURL=WeeklyGridHeader.js.map